import { useState, useEffect } from 'react';

import { fg } from '@confluence/feature-gating';
import { useIsCurrentPageLive } from '@confluence/live-pages-utils/entry-points/useIsCurrentPageLive';

export const useForgePageBannerListener = () => {
	const [forgeAppsHeight, setForgeAppsHeight] = useState(getForgeAppsHeight());

	const isLivePage = useIsCurrentPageLive();

	const isForgePageBannerFixed = !isLivePage;

	useEffect(() => {
		if (fg('forge-ui-enable-confluence-page-banner')) {
			const listener = () => {
				setForgeAppsHeight(getForgeAppsHeight());
			};

			if (isForgePageBannerFixed) {
				document.addEventListener('forgePageBannerHeightUpdated', listener);
			}

			return () => {
				if (isForgePageBannerFixed) {
					document.removeEventListener('forgePageBannerHeightUpdated', listener);
				}
			};
		}
	}, [isForgePageBannerFixed]);

	return {
		isForgePageBannerFixed,
		forgePageBannerHeight: forgeAppsHeight,
	};
};

const getForgeAppsHeight = () => {
	if (typeof document === 'undefined') {
		return 0;
	}

	return (
		parseInt(
			getComputedStyle(document.documentElement).getPropertyValue('--forge-page-banner-height'),
		) || 0
	);
};
